import Vue from 'vue'
import Router from 'vue-router'
import Login from './views/login.vue'
import Verbale from "./views/verbale"
import VerbaleSkeleton from "./views/verbaleSkeleton"
import VerbaleSP from "./views/verbaleSP"
import Home from "./views/home"
import Firma from "./views/modificaFirma"
import VerbaleGVR from "./views/verbaleGVR"
import VerbaleGVRIR from "./views/verbaleGVRIR"
import VerbaliRecenti from "./views/verbaliRecenti"
import VerbaleDismissione from "./views/verbaleDismissione"
import VerbaleMRV from "./views/verbaleMRV"
import VerbaleATEX from "./views/verbaleATEX"
import VerbaleSA from "./views/verbaleSA"
import VerbaleTERRE from "./views/verbaleTERRE"
import WindowTest from "./views/windowsTest.vue"
import RicercaVerbale from "./views/ricercaVerbale.vue"
import Veicoli from "./views/veicoli.vue"
import PianificazioneAttivita from "./views/pianificazioneAttivita.vue"
import GoogleMaps from "./views/googleMaps.vue"
import Smartcal from "./views/smartcal.vue"
import ScadenziarioVerificheRidotto from "./views/scadenziarioVerificheRidotto.vue"
import Straordinari from './views/straordinari.vue'

Vue.use(Router)

export default new Router({
  //mode: 'history',
  routes: [{
      path: '/login',
      name: 'login',
      component: Login,
      meta: {
        requiresAuth: false
      }
    },
    {
      path: "/verbale",
      name: "verbale",
      component: Verbale,
      meta: {
        requiresAuth: true
      }
    },
    {
      path:"/verbaleSPSC",
      name:"verbaleSP",
      component:VerbaleSP,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: "/verbaleSkeleton",
      name: "verbaleSkeleton",
      component: VerbaleSkeleton,
      meta: {
        requiresAuth: true
      }
    },{
      path:"/",
      name:"Home",
      component:Home,
      meta: {
        requiresAuth: true
      }
    },
    {
      path:"/firma",
      name:"firma",
      component:Firma,
      meta: {
        requiresAuth: true
      }
    },
    {
      path:"/verbaleGVR",
      name:"Verbale GVR",
      component:VerbaleGVR,
      meta: {
        requiresAuth: true
      }
    },
    {
      path:"/verbaleGVRIR",
      name: "Verbale GVRIR",
      component:VerbaleGVRIR,
      meta: {
        requiresAuth: true
      }
    },
    {
      path:"/recenti",
      name: "Verbali recenti",
      component:VerbaliRecenti,
      meta: {
        requiresAuth: true
      }
    },
    {
      path:"/verbaleDismissione",
      name: "Verbale dismissione",
      component:VerbaleDismissione,
      meta: {
        requiresAuth: true
      }
    },
    {
      path:"/windowTest",
      name: "WindowTest",
      component:WindowTest,
      meta: {
        requiresAuth: true
      }
    },
    {
      path:"/verbaleMRV",
      name: "verbaleMRV",
      component:VerbaleMRV,
      meta: {
        requiresAuth: true
      }
    },
    {
      path:"/verbaleATEX",
      name: "verbaleATEX",
      component:VerbaleATEX,
      meta: {
        requiresAuth: true
      }
    },
    {
      path:"/verbaleSA",
      name: "verbaleSA",
      component:VerbaleSA,
      meta: {
        requiresAuth: true
      }
    },
    {
      path:"/verbaleTERRE",
      name: "verbaleTERRE",
      component:VerbaleTERRE,
      meta: {
        requiresAuth: true
      }
    },
    {
      path:"/veicoli",
      name: "Veicoli",
      component: Veicoli,
      meta: {
        requiresAuth: true
      }
    },
    {
      path:"/ricercaVerbale",
      name: "Ricerca Verbale",
      component: RicercaVerbale,
      meta: {
        requiresAuth: true
      }
    },
    {
      path:"/pianificazioneAttivita",
      name: "Pianificazione Attività",
      component: PianificazioneAttivita,
      meta: {
        requiresAuth: true
      }
    },
    {
      path:"/googleMaps",
      name: "Google Maps",
      component: GoogleMaps,
      meta: {
        requiresAuth: true
      }
    },
    {
      path:"/smartcal",
      name: "Smartcal",
      component: Smartcal,
      meta: {
        requiresAuth: true
      }
    },
    {
      path:"/scadenziarioVerificheRidotto",
      name: "Scadenziario Verifiche Ridotto",
      component: ScadenziarioVerificheRidotto,
      meta: {
        requiresAuth: true
      }
    },
    {
      path:"/straordinari",
      name: "Straordinari",
      component: Straordinari,
      meta: {
        requiresAuth: true
      }
    }
  ]
})